import React from "react";
import "./uploadFileButton.scss";

const UploadFileButton = ({
  text,
  icon,
  eventHandler,
  iconRight,
  id,
  onHoverStyle,
  className
}) => {
  return (
    <div className={`upload-btn-wrapper text-uppercase`}>
      <div className={`fileUpload ${className} ${onHoverStyle ? "onHover" : ""}`}>
        <input type="file" className="upload" onChange={eventHandler} id={id} />
        <span>
          {!iconRight ? <i className={`fa ${icon}`} /> : null} {text}{" "}
          {iconRight ? <i className={`fa ${icon}`} /> : null}
        </span>
      </div>
    </div>
  );
};

export default UploadFileButton;



// WEBPACK FOOTER //
// ./src/components/common/buttons/uploadFileButton/uploadFileButton.jsx